import React from "react";
import './Services.css';
import services from "../../resources/data/services";
import arrow from "../../resources/assets/down_arrow.png";
import { useEffect } from "react";
import '../Global/Global.css';
import TextSignup from "../TextSignup/TextSignup";

function Services() {
  useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
      });
    }, { threshold: 0.4 });
      const paragraph = document.querySelectorAll('.service-item')
      paragraph.forEach((el) => observer.observe(el));
    }, []);
  return (
    <div className="services">
      <h2>Services
        <div class="contentDiv">
          <img class="arrow" src={arrow} alt="arrow" />
        </div>
      </h2>
      <div class="more-info">
        <p className="specials">
          Packages and specials are available, sign up to receive specials via text.
          <TextSignup buttonText="Click to Sign Up"/>
        </p>
      </div>
      <ul className="services-list">
        {services.map((service) => (
          <li key={service.id} className="service-item fade-in">
            <h3>{service.name}</h3>
            <p>{service.description}</p>
          </li>
        ))}
      </ul>
      <div className="more-info">
        <p className="other-treatments">
          Other medical oriented treatments are available and may be recommended based on need. Consults are complimentary.
        </p>
        <p className="availability">
          Available Monday, Wednesday, Friday by appointment only.
        </p>
      </div>
    </div>
  );
}

export default Services;